export default __webpack_public_path__ + "static/radem-99e8ad12fb46eb363160e9ccc242c15e.png";